import styled from "styled-components";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Section = styled.section`
    padding: 4rem 2rem;
    background: #fff;
    text-align: center;
`;

const Title = styled.h2`
    color: #0077b6;
    margin-bottom: 2rem;
`;

const Grid = styled.div`
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
`;

const Card = styled.div`
    background: #f1f1f1;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
`;

const Img = styled.img`
    width: 100%;
    height: 180px;
    object-fit: cover;
`;

const Label = styled.h3`
    padding: 1rem;
    color: #222;
`;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 8px;
  max-width: 600px;
  width: 90%;
  padding: 20px;
  text-align: center;
  position: relative;
`;

const ModalImage = styled.img`
    width: 100%;
    max-height: 300px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 15px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;

interface Service {
    img: string;
    title: string;
}

export const Services: React.FC = () => {
    const { t } = useTranslation();
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedService, setSelectedService] = useState<Service | null>(null);

    const services: Service[] = [
        { img: "/images/weightloss.png", title: "weightloss" },
        { img: "/images/women.png", title: "women" },
        { img: "/images/bodybuilding.png", title: "bodybuilding" },
        { img: "/images/fitness.png", title: "fitness" },
        { img: "/images/metabolic.png", title: "metabolic" },
        { img: "/images/sports.png", title: "sports" },
        { img: "/images/running.png", title: "running" }, // New service
        { img: "/images/weightlifting.jpg", title: "crossfitness" } // New service
    ];


    const openModal = (service: Service) => {
        setSelectedService(service);
        setModalOpen(true);
        document.body.classList.add("no-scroll");
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedService(null);
        document.body.classList.remove("no-scroll");
    };

    return (
        <Section id="services">
            <Title>{t("services.title")}</Title>
            <Grid>
                {services.map((s) => (
                    <Card key={s.title} onClick={() => openModal(s)}>
                        <Img src={s.img} alt={s.title} />
                        <Label>{t(`services.items.${s.title}.title`)}</Label>
                    </Card>
                ))}
            </Grid>

            {isModalOpen && selectedService && (
                <ModalOverlay onClick={closeModal}>
                    <ModalContent onClick={(e) => e.stopPropagation()}>
                        <CloseButton onClick={closeModal}>&times;</CloseButton>
                        <ModalImage src={selectedService.img} alt={selectedService.title} />
                        <h3>{t(`services.items.${selectedService.title}.title`)}</h3>
                        <p>{t(`services.items.${selectedService.title}.description`)}</p>
                    </ModalContent>
                </ModalOverlay>
            )}
        </Section>
    );
};
